import React from 'react';
import { connect } from 'react-redux';
import { Box } from '@mui/material';

import { State as RootState } from '@occc-app/rootRedux';

import { actions, State } from './redux';
import {
  AgeWithinConfiguration,
  InAnySegmentsConfiguration,
  InAllSegmentsConfiguration,
} from './components';

type Actions = typeof actions;

type AudienceBaseProps = {
  audienceConfigurationUpdate: Actions['audienceConfigurationUpdate'];
  editMode?: boolean;
  fieldDisabled: (field: any) => boolean;
};

type Props = State & typeof actions & { editMode?: boolean; readOnly: boolean };
class ShowAudiences extends React.Component<Props, {}> {
  renderAgeWithin(audienceBaseProps: AudienceBaseProps) {
    const { ageWithin, readOnly } = this.props;

    if (!ageWithin.active) {
      return;
    }

    const ageWithinProps = {
      ...audienceBaseProps,
      ...ageWithin,
      readOnly,
    };

    return <AgeWithinConfiguration {...ageWithinProps} />;
  }

  renderDivider() {
    const {
      ageWithin: { maximumAgeActive, minimumAgeActive },
      inAllSegments: { active: inAllSegmentsActive },
      inAnySegments: { active: inAnySegmentsActive },
      readOnly,
    } = this.props;

    const shouldRenderDivider =
      !readOnly ||
      (readOnly &&
        (maximumAgeActive || minimumAgeActive) &&
        (inAllSegmentsActive || inAnySegmentsActive));

    if (!shouldRenderDivider) {
      return;
    }

    return <Box borderTop='1px solid' borderColor='grayLight' mt={3} mb={2} />;
  }

  renderInAllSegments(audienceBaseProps: AudienceBaseProps) {
    const { inAllSegments } = this.props;

    if (!inAllSegments.active) {
      return;
    }

    const inAllSegmentsProps = {
      ...audienceBaseProps,
      ...inAllSegments,
    };
    return <InAllSegmentsConfiguration {...inAllSegmentsProps} />;
  }

  renderInAnySegments(audienceBaseProps: AudienceBaseProps) {
    const { inAnySegments } = this.props;

    if (!inAnySegments.active) {
      return;
    }

    const inAnySegmentsProps = {
      ...audienceBaseProps,
      ...inAnySegments,
    };
    return <InAnySegmentsConfiguration {...inAnySegmentsProps} />;
  }

  render() {
    const { audienceConfigurationUpdate, editMode, readOnly } = this.props;

    const audienceBaseProps: AudienceBaseProps = {
      audienceConfigurationUpdate,
      editMode,
      fieldDisabled: () => readOnly,
    };

    return (
      <Box>
        {this.renderAgeWithin(audienceBaseProps)}
        {this.renderDivider()}
        {this.renderInAllSegments(audienceBaseProps)}
        {this.renderInAnySegments(audienceBaseProps)}
      </Box>
    );
  }
}

type MapStateToProps = (state: RootState) => State;
const mapStateToProps: MapStateToProps = ({ offer: { audiences } }) => audiences;

export default connect(mapStateToProps, actions)(ShowAudiences);
